import cookie from 'cookie';
import CookiesPackage from 'universal-cookie';

export const Cookies = new CookiesPackage();
export const cookieParser = cookie;

export function getCookieValue(name: string): string | undefined {
  return cookieParser.parse(document.cookie)[name];
}
